// Elemento raíz del árbol React del bundle público del chart.
//
// En deploy standalone (chart.html) es <div id="root"> del propio
// documento. Cuando el shell unificado (quantum-web) monta este bundle
// dentro de un shadow root, document.getElementById('root') NO puede
// encontrarlo -- un shadow boundary no es atravesable por búsquedas de id
// del document exterior, es justo lo que lo hace un boundary. Por eso el
// shell, antes de inyectar el script de este bundle, deja el elemento ya
// creado en window.__QUANTUM_MOUNT_EL__ (ver AppMount en quantum-web) --
// se usa si existe, si no caemos al getElementById de siempre (deploy
// standalone).
export function getMountEl() {
  return window.__QUANTUM_MOUNT_EL__ || document.getElementById('root')
}

// URL base absoluta de ESTE bundle -- necesaria para cualquier recurso que
// no pueda resolverse por ruta relativa del propio módulo (registro del
// service worker, iconos leídos vía document.baseURI en PwaUi.jsx).
//
// En deploy standalone el documento ES el bundle (document.baseURI ya
// apunta a /app/ o donde se sirva), así que './' resuelve bien. Embebido
// en el shell, document.baseURI es la URL del SHELL (quantum-web) -- './'
// resolvería contra la raíz del shell, no contra /app/, rompiendo
// silenciosamente el registro del SW y los iconos de instalación (404).
// El shell deja el prefijo real en window.__QUANTUM_APP_BASE__ (ver
// AppMount) antes de inyectar el script de este bundle.
export function getAppBase() {
  const raw = window.__QUANTUM_APP_BASE__ || './'
  return new URL(raw, document.baseURI).href
}
